<template>
  <section class="c-message c-message--narrow c-message--centered">
    <div
      v-if="loadStatus === 'empty'"
    >
      <h2>Ingen boliger</h2>
      <p>Vi fant ingen boliger i databasen vår. Det betyr mest sannsynlig at vi holder på å bygge opp databasen og boligvelgeren ikke er klar helt enda.</p>
      <p><strong>Vennligst prøv igjen på et senere tidspunkt.</strong></p>
    </div>
    <div
      v-else
    >
      <h2>Innlastingsfeil.</h2>
      <p>Det skjedde noe feil når vi prøvde å hente boligene. Prøv å laste inn siden på nytt, eller prøv igjen på et senere tidspunkt.</p>
      <p>Hvis du fortsatt opplever problemer med boligvelgeren setter vi stor pris på om du <a href="mailto:web.ensign@gmail.com?subject=Melding om feil i boligvelger">melder fra til oss på e-post</a>.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ErrorMessage',
  computed: {
    loadStatus() {
      return this.$store.state.entities.residences.loadStatus;
    },
  },
};
</script>